var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { DropdownOption } from '../../../classes/definitions/formItem/ElementConfig';
import * as MainStaticPageFactory from "../../../classes/definitions/mainStaticPage/mainStaticPage";
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import mainStaticPageSchema from "../../../schemas/mainStaticPageSchema";
import MainStaticPagesService from '../../../services/mainStaticPages.service';
import Input from '../../UI/Input/Input';
import { withRouter } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import Email from '../../UI/Builder/Builder'; // Adjust the import path for Email component
var MainStaticPageForm = /** @class */ (function (_super) {
    __extends(MainStaticPageForm, _super);
    function MainStaticPageForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.mainStaticPagesService = new MainStaticPagesService(_this.api);
        _this.imageChanged = false; // this will determine if the image has been changed
        // if no changes, no image prop will be sent to the backend
        _this.state = {
            formConfig: _.cloneDeep(mainStaticPageSchema),
            formIsValid: false,
            discardPopupVisble: false,
            showModal: false,
            currentId: '',
            currentModalContent: {
                designHtml: '',
                designJson: null,
            },
        };
        // Setting up the options to all fields that need async data
        // after the options are all set up, then we'll load the data for edit
        _this.setupFieldsOptions = function (data) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            // Setting up the Option Value field based on the parent product
            _this.setPageTypes(updatedFormConfig, _.get(data, 'types.page_types'));
            // this.setupOptionValues(updatedFormConfig, _.get(data, 'optionTypes.data'));
            _this.setState({ formConfig: updatedFormConfig }, function () {
                // After setting up the async options
                if (_this.editId !== '-1') {
                    _this.getMainStaticPage(_this.editId);
                }
            });
        };
        _this.setPageTypes = function (updatedFormConfig, rawPageTypes) {
            for (var key in rawPageTypes) {
                if (Object.prototype.hasOwnProperty.call(rawPageTypes, key)) {
                    updatedFormConfig.page_type.elementConfig.options.push(new DropdownOption({
                        label: key,
                        value: key
                    }));
                }
            }
        };
        _this.getMainStaticPage = function (id) {
            _this.api.getMainStaticPage(id)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на статична страница';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var mainStaticPage = MainStaticPageFactory.createMainStaticPage(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'bg_name.value', mainStaticPage.BgName);
            _.set(updatedFormConfig, 'bg_name.touched', true);
            _.set(updatedFormConfig, 'bg_name.valid', true);
            _.set(updatedFormConfig, 'en_name.value', mainStaticPage.EnName);
            _.set(updatedFormConfig, 'en_name.touched', true);
            _.set(updatedFormConfig, 'en_name.valid', true);
            _.set(updatedFormConfig, 'slug.value', mainStaticPage.Slug);
            _.set(updatedFormConfig, 'slug.touched', true);
            _.set(updatedFormConfig, 'slug.valid', true);
            _.set(updatedFormConfig, 'position.value', mainStaticPage.Position);
            _.set(updatedFormConfig, 'position.touched', true);
            _.set(updatedFormConfig, 'position.valid', true);
            _.set(updatedFormConfig, 'page_type.value', mainStaticPage.PageType);
            _.set(updatedFormConfig, 'page_type.touched', true);
            _.set(updatedFormConfig, 'page_type.valid', true);
            // _.set(updatedFormConfig, 'bg_description.value', mainStaticPage.BgDescription);
            // _.set(updatedFormConfig, 'bg_description.touched', true);
            // _.set(updatedFormConfig, 'bg_description.valid', true);
            // _.set(updatedFormConfig, 'en_description.value', mainStaticPage.EnDescription);
            // _.set(updatedFormConfig, 'en_description.touched', true);
            // _.set(updatedFormConfig, 'en_description.valid', true);
            _.set(updatedFormConfig, 'canonical_url.value', mainStaticPage.CanonicalUrl);
            _.set(updatedFormConfig, 'canonical_url.touched', true);
            _.set(updatedFormConfig, 'canonical_url.valid', true);
            var addValueFromCorrespondingElement = function (obj) {
                for (var key in obj) {
                    if (obj[key].elementType === "buttonModal") {
                        var correspondingKey = key.replace("_json", "");
                        if (obj[correspondingKey]) {
                            obj[key].value = obj[correspondingKey].value;
                            obj[key].valueJson = {
                                body: {
                                    id: "" + correspondingKey,
                                    rows: [
                                        {
                                            id: "" + correspondingKey,
                                            cells: [
                                                {
                                                    contents: []
                                                }
                                            ],
                                            columns: [
                                                {
                                                    id: "LW0qh6mDEB",
                                                    contents: [
                                                        {
                                                            id: "9I7WSiTa5e",
                                                            type: "html",
                                                            values: {
                                                                html: "" + obj[correspondingKey].value,
                                                                displayCondition: null,
                                                                containerPadding: "10px",
                                                                anchor: "",
                                                                _meta: {
                                                                    htmlID: "u_content_html_1",
                                                                    htmlClassNames: "u_content_html"
                                                                },
                                                                selectable: true,
                                                                draggable: true,
                                                                duplicatable: true,
                                                                deletable: true,
                                                                hideable: true
                                                            }
                                                        }
                                                    ],
                                                }
                                            ],
                                        }
                                    ],
                                },
                            };
                        }
                    }
                }
            };
            if (mainStaticPage.BgDescriptionJson === null) {
                addValueFromCorrespondingElement(updatedFormConfig);
            }
            else {
                _.set(updatedFormConfig, 'bg_description_json.valueJson', mainStaticPage.BgDescriptionJson);
                _.set(updatedFormConfig, 'bg_description_json.touched', true);
                _.set(updatedFormConfig, 'bg_description_json.valid', true);
                _.set(updatedFormConfig, 'bg_description_json.value', mainStaticPage.BgDescription);
            }
            if (mainStaticPage.EnDescriptionJson === null) {
                addValueFromCorrespondingElement(updatedFormConfig);
            }
            else {
                _.set(updatedFormConfig, 'en_description_json.valueJson', mainStaticPage.EnDescriptionJson);
                _.set(updatedFormConfig, 'en_description_json.touched', true);
                _.set(updatedFormConfig, 'en_description_json.valid', true);
                _.set(updatedFormConfig, 'en_description_json.value', mainStaticPage.EnDescription);
            }
            _this.setState({ formConfig: updatedFormConfig, formIsValid: NotosService.checkFormValidity(updatedFormConfig) });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            if (id === 'image_url' && updatedFormElement.valid) {
                _this.imageChanged = true;
            }
            _this.setState({ formConfig: updatedFormConfig, formIsValid: NotosService.checkFormValidity(updatedFormConfig) }, function () {
                console.log(_this.state.formConfig);
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedStaticPage = MainStaticPageFactory.createMainStaticPage({
                bg_name: _.get(formData, 'bg_name.value', ''),
                en_name: _.get(formData, 'en_name.value', ''),
                slug: _.get(formData, 'slug.value', ''),
                position: _.get(formData, 'position.value', ''),
                page_type: _.get(formData, 'page_type.value', ''),
                bg_description: _.get(formData, 'bg_description_json.value', ''),
                bg_description_json: JSON.stringify(_.get(formData, 'bg_description_json.valueJson', '')),
                en_description: _.get(formData, 'en_description_json.value', ''),
                en_description_json: JSON.stringify(_.get(formData, 'en_description_json.valueJson', '')),
                canonical_url: _.get(formData, 'canonical_url.value', ''),
            });
            var actionMethod = _this.editId === '-1' ? _this.api.createMainStaticPage : _this.api.updateMainStaticPage;
            actionMethod(submittedStaticPage, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.toMainStaticPagesPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на статична страница';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        // Method to open the modal
        _this.openModal = function (formElementId) {
            var formElement = _this.state.formConfig[formElementId];
            // console.log(formElement)
            _this.setState({
                showModal: true,
                currentId: formElementId,
                currentModalContent: {
                    designHtml: formElement.value || null,
                    designJson: formElement.valueJson || null,
                },
            });
        };
        // Method to close the modal
        _this.closeModal = function () {
            _this.setState({
                showModal: false,
                currentModalContent: {
                    designHtml: '',
                    designJson: null,
                },
            });
        };
        _this.showInfoModal = function () {
            _this.setState({
                showModal: false,
                currentModalContent: {
                    designHtml: _this.state.currentModalContent.designHtml,
                    designJson: _this.state.currentModalContent.designJson,
                },
            });
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[_this.state.currentId]);
            updatedFormElement.value = _this.state.currentModalContent.designHtml.replace(/\n/g, '');
            updatedFormElement.valueJson = _this.state.currentModalContent.designJson;
            var prevId = _this.state.currentId.replace("_json", "");
            updatedFormConfig[_this.state.currentId] = updatedFormElement;
            if (updatedFormConfig[prevId]) {
                updatedFormConfig[prevId].value = _this.state.currentModalContent.designHtml.replace(/\n/g, '');
            }
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.toMainStaticPagesPage = function () {
            _this.props.history.push(AppRoutes.staticPages.path);
        };
        // Method to handle design export from Email component
        _this.handleDesignExport = function (html, json) {
            _this.setState(function (prevState) { return ({
                currentModalContent: {
                    designHtml: html || '',
                    designJson: json
                },
            }); });
        };
        return _this;
    }
    MainStaticPageForm.prototype.componentDidMount = function () {
        var _this = this;
        this.editId = _.get(this.props, 'match.params.staticPageId', '-1');
        if (this.editId !== '-1') {
            this.props.isEdit(true);
        }
        this.mainStaticPagesService.fetchAsyncFieldsOptions()
            .then(function (data) {
            _this.setupFieldsOptions(data);
        })
            .catch(function (error) {
            var defaultMessage = 'Опциите за някое или за всички полета не можаха да бъдат заредени. Опитайте отново!';
            _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
        });
    };
    MainStaticPageForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, showModal = _a.showModal, currentModalContent = _a.currentModalContent, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        var modalInfo;
        if (formConfig.hasOwnProperty(this.state.currentId)) {
            modalInfo = {
                config: formConfig[this.state.currentId],
                id: this.state.currentId
            };
        }
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key
                });
            }
        }
        // Building form inputs
        var form = (formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType); }, modalButtonAction: function (event) { return _this.openModal(formElement.id); }, buttonModalText: "Промяна на съдържанието", modalhtmlContent: formElement.config.value && Object.keys(formElement.config.value).length > 0 ? formElement.config.value : null, modalButton: formElement.config.elementType === 'buttonModal' ? true : false }));
        }));
        // Modal content
        var modalContent = showModal && currentModalContent ? (React.createElement(Dialog, { visible: showModal, onHide: this.closeModal, header: "\u041F\u0440\u043E\u043C\u044F\u043D\u0430 \u043D\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435\u0442\u043E" },
            React.createElement("div", null,
                React.createElement(Email, { onDesignExport: this.handleDesignExport, designHtml: modalInfo.config.value, designJson: modalInfo.config.valueJson })),
            React.createElement("div", { className: "p-d-flex p-jc-end" },
                React.createElement(Button, { label: "Close", onClick: this.closeModal }),
                React.createElement(Button, { label: "Save", onClick: this.showInfoModal })))) : null;
        var actionBtns = React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toMainStaticPagesPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK"));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
            form,
            modalContent,
            actionBtns));
    };
    return MainStaticPageForm;
}(React.Component));
// @ts-ignore
export default withRouter(MainStaticPageForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/MainStaticPages/MainStaticPageForm/MainStaticPageForm.tsx
// module id = 365
// module chunks = 0